import script from "./SliderViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./SliderViewer.vue?vue&type=script&setup=true&lang=js"

import "./SliderViewer.vue?vue&type=style&index=0&id=5e53e43c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e53e43c"]])

export default __exports__